import React from 'react';


import { usePlateDropDownSelectedData } from '../../store/plateWellStore';
import useFetchQlp96WellMetrics from '../Hooks/qlp_ddpcr/useFetchQlp96WellMetrics';
import { cssClassForPlateData, formatValue } from "../../utils/basic";
import { useParams } from 'react-router-dom';


const PlateToolBar = () => {

    const plateData = usePlateDropDownSelectedData();
    const { plate_uuid, filename } = useParams();
    const { data, isSuccess } = useFetchQlp96WellMetrics(plate_uuid);
    const plateName = isSuccess ? data?.data[3] : '';



    const isChannelData = (item) => {
        const keys = Object.keys(item);
        return typeof item[keys[0]] === 'object' && item[keys[0]] !== null;
    };

    return (
        <>
            <div className='flex flex-col'>
                <div>
                    {plateData.map((item, index) => (
                        <div key={crypto.randomUUID()}>
                            {isChannelData(item) ? (
                                // Handling channel data
                                Object.entries(item).map(([channel, channelData]) => (
                                    <div className='flex space-x-2' key={crypto.randomUUID()}>

                                        <p className={`${cssClassForPlateData(channel)} pb-1 font-extrabold text-[11px]`}>Plate {channel} Mean:{formatValue(channelData["Plate Mean"])}</p>
                                        <p className={`${cssClassForPlateData(channel)} font-extrabold text-[11px]`}>Plate {channel} Std Dev:{formatValue(channelData["Plate Stdev"])}</p>
                                    </div>
                                ))
                            ) : (
                                // Handling direct data

                                <div className='flex flex-col'>
                                    <span className='pb-1 font-extrabold text-[11px]'>Plate Mean:{formatValue(item["Plate Mean"])}</span>
                                    <span className='font-extrabold text-[11px]'>Plate Std Dev:{formatValue(item["Plate Stdev"])}</span>
                                </div>

                            )}
                        </div>
                    ))}
                </div>
                <div className='pt-0 text-[11px]'>
                    <span className='font-bold text-custom-green'>Plate Name: {plateName}</span>
                </div>
                {filename && (
                    <div className='pt-0 text-[11px]'>
                        <span className='font-bold text-custom-green'>File Name: {decodeURIComponent(filename)}</span>
                    </div>
                )}
            </div>
        </>
    );
};

export default PlateToolBar;

